import { render, staticRenderFns } from "./VPageNotFound.vue?vue&type=template&id=fdb64ab8&"
import script from "./VPageNotFound.vue?vue&type=script&lang=js&"
export * from "./VPageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports